import type { HomeworkAssignmentSnapshot } from '@wx-weiqi/contracts';

import {
  STUDENT_HOMEWORK_STATUSES,
  studentHomeworkListAction,
} from '../domain/homework-list-presentation';
import { HomeworkListPanel, type HomeworkListRow } from './HomeworkListPanel';

export function StudentHomeworkListPanel({
  assignments,
  loading,
  busy,
  error,
  onOpen,
  onRefresh,
}: {
  readonly assignments: readonly HomeworkAssignmentSnapshot[];
  readonly loading: boolean;
  readonly busy: boolean;
  readonly error: string | null;
  readonly onOpen: (assignment: HomeworkAssignmentSnapshot) => void;
  readonly onRefresh: () => void;
}) {
  const rows: HomeworkListRow[] = assignments.map((assignment) => {
    const answered = new Set(assignment.submissions.map((submission) => submission.problemId));
    const completed = assignment.items.filter((item) =>
      answered.has(item.problem.problemId),
    ).length;
    return {
      id: assignment.assignmentId,
      title: assignment.title,
      date: assignment.assignedAt,
      dueAt: assignment.dueAt,
      metadata: `${assignment.items.length} 题 · 每题 ${assignment.timeLimitSeconds >= 60 ? `${assignment.timeLimitSeconds / 60} 分钟` : `${assignment.timeLimitSeconds} 秒`}`,
      status: STUDENT_HOMEWORK_STATUSES[assignment.status],
      progress: {
        label: `已提交 ${completed} / ${assignment.items.length} 题`,
        value: completed,
        total: assignment.items.length,
      },
      action: studentHomeworkListAction(assignment.status),
    };
  });
  return (
    <HomeworkListPanel
      rows={rows}
      statuses={Object.values(STUDENT_HOMEWORK_STATUSES)}
      dateLabel="收到作业日期"
      description="按日期查看作业，继续练习或回看批改结果。"
      emptyTitle="暂时没有作业"
      loading={loading}
      busy={busy}
      error={
        error ? (
          <p className="message message--error" role="alert">
            {error}
          </p>
        ) : null
      }
      onRefresh={onRefresh}
      onOpen={(id) => {
        const assignment = assignments.find((item) => item.assignmentId === id);
        if (assignment) onOpen(assignment);
      }}
    />
  );
}
